const config = {
  primaryColour: '#28646e',
};

export default config;
